// removed by extract-text-webpack-plugin
module.exports = {"Region":"Region__Region___3zQBe","Text":"Region__Text___2ffDj","Icon":"Region__Icon___1eYEW","Dropdown":"Region__Dropdown___2OFEs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Region/Region.scss
// module id = 1410
// module chunks = 0